import { Minus, Plus } from "lucide-react";
import { CONTROL, KIT } from "./kit-tokens";

/** A one-line number stepper: label on the start side, minus / count / plus. */
export function KitStepper({
  label,
  value,
  min,
  max,
  onChange,
  lessLabel,
  moreLabel,
  icon,
}: {
  label: string;
  value: number;
  min: number;
  max: number;
  onChange: (n: number) => void;
  lessLabel: string;
  moreLabel: string;
  icon?: React.ReactNode;
}) {
  return (
    <div className="flex items-center justify-between gap-3">
      <span className="inline-flex items-center gap-1.5 text-[13px] font-semibold" style={{ color: KIT.navy }}>
        {icon}
        {label}
      </span>
      <span className="flex items-center gap-1 rounded-full p-1" style={CONTROL}>
        <button
          type="button"
          aria-label={lessLabel}
          disabled={value <= min}
          onClick={() => onChange(Math.max(min, value - 1))}
          className="grid h-8 w-8 place-items-center rounded-full disabled:opacity-35"
          style={{ color: KIT.navy }}
        >
          <Minus size={14} aria-hidden />
        </button>
        <span
          aria-live="polite"
          className="w-6 text-center text-[14px] font-semibold tabular-nums"
          style={{ color: KIT.navy }}
        >
          {value}
        </span>
        <button
          type="button"
          aria-label={moreLabel}
          disabled={value >= max}
          onClick={() => onChange(Math.min(max, value + 1))}
          className="grid h-8 w-8 place-items-center rounded-full disabled:opacity-35"
          style={{ color: KIT.navy }}
        >
          <Plus size={14} aria-hidden />
        </button>
      </span>
    </div>
  );
}
